import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewUpdateResultsComponent } from './view-update-results.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SidenavHeaderModule } from 'src/app/components/sidenav-header/sidenav-header.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { SearchFilterModule } from '../../../components/search-filter/search-filter.module';



@NgModule({
  declarations: [
    ViewUpdateResultsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    PipesModule,
    IconsModule,
    SidenavHeaderModule,
    PaginatorModule,
    SearchFilterModule,
  ], exports: [
    ViewUpdateResultsComponent
  ],
})
export class ViewUpdateResultsModule { }
